import React from 'react';
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { makeStyles } from "@material-ui/core/styles";
import { IoClose } from "react-icons/io5";

const useStyles = makeStyles(() => ({
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9998,
        backdropFilter: 'blur(0.5px)',
    },
    popupContainer: {
        position: 'fixed',
        width: '603px',
        height: '143px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        padding: '0',
    },
    titleContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontFamily: 'Poppins',
        fontWeight: 500,
        fontSize: '15px',
        lineHeight: '100%',
        letterSpacing: '0%',
        backgroundColor: 'rgba(244, 244, 244, 1)',
        padding: '10px 15px',
        borderRadius: '8px 8px 0 0',
        borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
    },
    closeButton: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        color: 'rgba(0, 0, 0, 0.5)',
        fontSize: '18px',
        '&:hover': {
            color: 'rgba(0, 0, 0, 0.8)',
        },
    },
    body: {
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'Poppins',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '100%',
        letterSpacing: '0%',
        color: 'rgba(60, 101, 86, 1)',
        padding: '20px',
        flex: 1,
    },
    icon: {
        color: 'rgb(203, 213, 66)',
        marginRight: '10px',
        fontSize: '20px',
    },
}));

const ForcageSuccessPopup = ({ onClose }) => {
    const classes = useStyles();

    return (
        <>
            <div className={classes.overlay} onClick={onClose} />
            <div className={classes.popupContainer}>
                <div className={classes.titleContainer}>
                    Notification
                    <button className={classes.closeButton} onClick={onClose}>
                        <IoClose />
                    </button>
                </div>
                <div className={classes.body}>
                    <IoMdCheckmarkCircleOutline className={classes.icon} />
                    Opération de forçage effectuée avec succès
                </div>
            </div>
        </>
    );
};

export default ForcageSuccessPopup;